module.exports = __webpack_public_path__ + "static/media/spotify.cc4e2784.png";